import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import StatCard from "./StatCard";
import ChatDetailsModal from "./ChatDetailsModal";
import { subDays, format, parseISO } from "date-fns";

const ChatDetails = ({ chatDetails }) => {
  const [dailyCounts, setDailyCounts] = useState([]);
  const [labels, setLabels] = useState([]);
  const [trend, setTrend] = useState("neutral");
  const [detailsOpen, setDetailsOpen] = useState(false);

  const getTrend = (counts) => {
    const len = counts.length;
    if (len < 2) return "neutral";
    const prev = counts[len - 2];
    const current = counts[len - 1];
    if (current > prev) return "up";
    if (current < prev) return "down";
    return "neutral";
  };

  const processChatDataByDay = (chats) => {
    const now = new Date();
    const dateMap = new Map();

    // Initialize map with last 30 days
    for (let i = 29; i >= 0; i--) {
      const d = subDays(now, i);
      const key = format(d, "yyyy-MM-dd");
      dateMap.set(key, 0);
    }

    // Count chats per day
    chats.forEach((chat) => {
      const createdDate = format(parseISO(chat.createdAt), "yyyy-MM-dd");
      if (dateMap.has(createdDate)) {
        dateMap.set(createdDate, dateMap.get(createdDate) + 1);
      }
    });

    // Prepare data arrays
    const counts = Array.from(dateMap.values());
    const labels = Array.from(dateMap.keys()).map((d) =>
      format(new Date(d), "dd MMM")
    );

    return { counts, labels };
  };

  useEffect(() => {
    if (chatDetails && chatDetails.length > 0) {
      const last30DaysChats = chatDetails.filter(
        (chat) =>
          new Date(chat.createdAt) >= new Date(Date.now() - 30 * 86400000)
      );

      const { counts, labels } = processChatDataByDay(last30DaysChats);

      setDailyCounts(counts);
      setLabels(labels);
      setTrend(getTrend(counts));
    }
  }, [chatDetails]);

  return (
    <Box sx={{ width: "100%" }}>
      <StatCard
        title="Last 30 Days Chats"
        value={dailyCounts.reduce((a, b) => a + b, 0).toLocaleString()}
        interval="Last 30 days"
        trend={trend}
        data={dailyCounts}
        labels={labels}
        onClick={() => setDetailsOpen(true)}
      />
      <ChatDetailsModal
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        chatDetails={chatDetails}
      />
    </Box>
  );
};

export default ChatDetails;
